import React from 'react';
import { Form, TextArea } from 'semantic-ui-react';


const ScriptEditor = function(props) {
  const src = props.src;
  const setSrc = props.onSave;

  return (
  <Form>
    <TextArea className='lua'
              placeholder='Lua script...'
              value={src}
              onChange={(e,d) => setSrc(d.value)} />
  </Form>
  );
}

export default ScriptEditor;
